// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientSummaryDiagnosis {
    static getAttributeTypeMap() {
        return MangoHubGetPatientSummaryDiagnosis.attributeTypeMap;
    }
}
MangoHubGetPatientSummaryDiagnosis.discriminator = undefined;
MangoHubGetPatientSummaryDiagnosis.additionalProperties = false;
MangoHubGetPatientSummaryDiagnosis.attributeTypeMap = [
    {
        "name": "diagnosisCode",
        "baseName": "diagnosisCode",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
];
//# sourceMappingURL=mangoHubGetPatientSummaryDiagnosis.js.map